<!-- <p>pre-approved-visitor-dialog works!</p> -->

<!-- <h2 matDialogTitle>Pre-Approved Visitor</h2> -->
<div
  [ngClass]="{
    'pre-approved-visitor-dialog-container':
      screenSize == ScreenType.Desktop || screenSize == ScreenType.Tablet,

    'pre-approved-visitor-dialog-container-mobile':
      screenSize == ScreenType.Mobile
  }"
>
  <!-- <h6><i>Notifying the Visitor of arrival!</i></h6> -->
  <section class="pre-approved-visitor-content">
    <div
      [ngClass]="{
        'visitor-gate-entry-header':
          screenSize == ScreenType.Desktop || screenSize == ScreenType.Tablet,

        'visitor-gate-entry-header-mobile': screenSize == ScreenType.Mobile
      }"
    >
      Pre-Approved Visitor
      <button mat-mini-fab mat-dialog-close>
        <mat-icon>clear</mat-icon>
      </button>
    </div>
    <mat-divider></mat-divider>
    <div
      [ngClass]="{
        'visitor-gate-entry-form':
          screenSize == ScreenType.Desktop || screenSize == ScreenType.Tablet,

        'visitor-gate-entry-form-mobile': screenSize == ScreenType.Mobile
      }"
    >
      <form [formGroup]="visitorGateEntryPass">
        <mat-grid-list
          [cols]="screenSize == ScreenType.Mobile ? 1 : 3"
          rowHeight="80px"
          gutterSize="15px"
        >
          <mat-grid-tile [rowspan]="screenSize == ScreenType.Mobile ? 4 : 5">
            <div class="open-camera-visitor-entry">
              <div *ngIf="showWebcam">
                <webcam
                  [trigger]="invokeObservable"
                  [switchCamera]="nextWebcamObservable"
                  (imageCapture)="captureImg($event)"
                  [width]="screenSize == ScreenType.Mobile ? 250 : 350"
                  [height]="screenSize == ScreenType.Mobile ? 225 : 350"
                ></webcam>
              </div>
              <div *ngIf="!showWebcam" class="captured-image-container">
                <img [src]="sysImage" />
              </div>

              <div class="open-camera-button">
                <div>
                  <mat-form-field
                    subscriptSizing="dynamic"
                    appearance="outline"
                  >
                    <mat-label>Select Camera</mat-label>
                    <mat-select
                      [disabled]="isDisabled"
                      [value]="deviceSelected"
                      (valueChange)="onDeviceSelectChange($event)"
                    >
                      <mat-option
                        *ngFor="let device of availableDevices"
                        [value]="device.deviceId"
                        >{{ device.label }}</mat-option
                      >
                    </mat-select>
                  </mat-form-field>
                </div>
                <button
                  [disabled]="!isDeviceSelected"
                  (click)="getSnapshot()"
                  mat-raised-button
                >
                  {{
                    showWebcam || !isDeviceSelected ? "Capture" : "ReCapture"
                  }}
                </button>
              </div>
            </div>
          </mat-grid-tile>
          <mat-grid-tile
            *ngIf="
              (!isUniqueVisitor && isValid) ||
              (!isUniqueVisitor && !isValid && !isManuallyCheck) ||
              (!isUniqueVisitor && !isValid && isManuallyCheck) ||
              (isUniqueVisitor && isApiCalled)
            "
            [colspan]="screenSize == ScreenType.Mobile ? '1' : '1'"
          >
            <div class="form-field-updates">
              <div
                *ngIf="!isUniqueVisitor && isValid"
                class="warn-banner"
                [ngStyle]="
                  screenSize != ScreenType.Mobile
                    ? { 'font-size': '14px' }
                    : screenSize == ScreenType.Mobile
                    ? { 'font-size': '12px' }
                    : {}
                "
              >
                <div class="warn-banner-text">
                  {{ phoneForm.get("phone").value }} already exists, Please
                  re-schedule!
                </div>
                <button (click)="onEditDetails()" mat-raised-button>
                  Edit Record
                </button>
                <div
                  *ngIf="!isUniqueVisitor && isValid"
                  class="searched-image-container"
                >
                  <img [src]="searchedImage" alt="Searched Image" />
                </div>
              </div>

              <div
                *ngIf="!isUniqueVisitor && !isValid && !isManuallyCheck"
                class="error-banner"
                [ngStyle]="
                  screenSize != ScreenType.Mobile
                    ? { 'font-size': '16px' }
                    : screenSize == ScreenType.Mobile
                    ? { 'font-size': '14px' }
                    : {}
                "
              >
                <div class="prompt-message">
                  {{ phoneForm.get("phone").value }} not yet checked-out!
                </div>
                <button (click)="onManualCheckVisitor()" mat-raised-button>
                  Check-Out
                </button>
              </div>
              <div
                *ngIf="
                  isUniqueVisitor &&
                  isApiCalled &&
                  phoneForm.get('phone')?.value
                "
                class="success-banner"
                [ngStyle]="{
                  'font-size':
                    screenSize === ScreenType.Mobile ? '14px' : '16px'
                }"
              >
                <div class="prompt-message">
                  {{ phoneForm.get("phone")?.value }} is a new visitor!
                </div>
              </div>

              <div
                *ngIf="!isUniqueVisitor && !isValid && isManuallyCheck"
                class="warn-banner"
                [ngStyle]="
                  screenSize != ScreenType.Mobile
                    ? { 'font-size': '16px' }
                    : screenSize == ScreenType.Mobile
                    ? { 'font-size': '14px' }
                    : {}
                "
              >
                <div class="prompt-message">
                  {{ phoneForm.get("phone").value }} been manually checked-out!
                </div>
                <button (click)="onEditDetails()" mat-raised-button>
                  Edit Record
                </button>
              </div>
            </div>
          </mat-grid-tile>
          <form class="phone-form-field" #f="ngForm" [formGroup]="phoneForm">
            <mat-grid-tile>
              <mat-form-field
                class="custom-padding-fix"
                appearance="outline"
                subscriptSizing="dynamic"
              >
                <ngx-mat-intl-tel-input
                  #phoneInput
                  [enablePlaceholder]="true"
                  [required]="true"
                  [preferredCountries]="['in']"
                  [enableSearch]="true"
                  name="phone"
                  formControlName="phone"
                  [inputPlaceholder]="'Phone Number*'"
                  [label]="'Phone Number'"
                  [maxlength]="15"
                  (change)="onChangeNumber($event)"
                  (keypress)="inputValidator($event)"
                ></ngx-mat-intl-tel-input>
              </mat-form-field>
            </mat-grid-tile>
          </form>
          <mat-grid-tile
            ><mat-form-field
              hideRequiredMarker
              subscriptSizing="dynamic"
              appearance="outline"
            >
              <mat-label>Visitor ID</mat-label>
              <input matInput formControlName="visitorID" /> </mat-form-field
          ></mat-grid-tile>
          <mat-grid-tile
            ><mat-form-field
              hideRequiredMarker
              subscriptSizing="dynamic"
              appearance="outline"
            >
              <mat-label>First Name</mat-label>
              <input matInput formControlName="firstName" /> </mat-form-field
          ></mat-grid-tile>
          <mat-grid-tile
            ><mat-form-field
              hideRequiredMarker
              subscriptSizing="dynamic"
              appearance="outline"
            >
              <mat-label>Last Name</mat-label>
              <input matInput formControlName="lastName" /> </mat-form-field
          ></mat-grid-tile>
          <mat-grid-tile
            ><mat-form-field
              hideRequiredMarker
              subscriptSizing="dynamic"
              appearance="outline"
            >
              <mat-label>Email</mat-label>
              <input matInput formControlName="email" /> </mat-form-field
          ></mat-grid-tile>
          <mat-grid-tile *ngIf="false">
            <!-- <mat-form-field
              hideRequiredMarker
              subscriptSizing="dynamic"
              appearance="outline"
            >
              <mat-label>Contact Number</mat-label>
              <input
                (keypress)="inputValidator($event)"
                matInput
                maxlength="10"
                formControlName="phoneNumber"
              /> </mat-form-field
          > -->
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <ngx-mat-intl-tel-input
                #phoneInput
                [enablePlaceholder]="true"
                [required]="true"
                [preferredCountries]="['in']"
                [enableSearch]="true"
                name="phone"
                formControlName="phoneNumber"
                [inputPlaceholder]="'Phone Number *'"
                [label]="'Phone Number'"
                [maxlength]="15"
                (change)="onChangeNumber($event)"
              ></ngx-mat-intl-tel-input>
              <mat-error
                *ngIf="visitorGateEntryPass.controls['phoneNumber']?.errors?.['validatePhoneNumber']
              &&
              false"
                ><i>Enter valid number</i>
              </mat-error>
            </mat-form-field>
          </mat-grid-tile>
          <mat-grid-tile *ngIf="false">
            <mat-form-field
              hideRequiredMarker
              subscriptSizing="dynamic"
              appearance="outline"
            >
              <mat-label>Address</mat-label>

              <textarea
                formControlName="visitorAddress"
                cdkTextareaAutosize
                cdkAutosizeMinRows="1"
                cdkAutosizeMaxRows="1"
                matInput
              ></textarea>
            </mat-form-field>
          </mat-grid-tile>
          <mat-grid-tile
            ><mat-form-field
              subscriptSizing="dynamic"
              appearance="outline"
              hideRequiredMarker
            >
              <mat-label>Gender</mat-label>
              <mat-select formControlName="gender">
                <mat-option value="male">Male</mat-option>
                <mat-option value="female">Female</mat-option>
                <mat-option value="other">Other</mat-option>
              </mat-select>
            </mat-form-field></mat-grid-tile
          >
          <mat-grid-tile
            ><mat-form-field
              hideRequiredMarker
              subscriptSizing="dynamic"
              appearance="outline"
            >
              <mat-label>Purpose</mat-label>

              <mat-select formControlName="purpose">
                <mat-option value="Personal"> Personal </mat-option>
                <mat-option value="Official"> Official </mat-option>
                <mat-option value="Delivery"> Delivery </mat-option>
                <mat-option value="Meeting"> Meeting </mat-option>
                <mat-option value="Private"> Private </mat-option>
                <mat-option value="Classified"> Classified </mat-option>
              </mat-select>
            </mat-form-field></mat-grid-tile
          ><mat-grid-tile
            ><mat-form-field
              hideRequiredMarker
              subscriptSizing="dynamic"
              appearance="outline"
            >
              <mat-label>Meeting With</mat-label>

              <input matInput formControlName="hostName" /> </mat-form-field
          ></mat-grid-tile>
          <mat-grid-tile
            ><mat-form-field
              hideRequiredMarker
              subscriptSizing="dynamic"
              appearance="outline"
            >
              <mat-label>Visitor Category</mat-label>
              <input
                matInput
                formControlName="visitorCategory"
              /> </mat-form-field
          ></mat-grid-tile>

          <mat-grid-tile>
            <mat-form-field
              hideRequiredMarker
              subscriptSizing="dynamic"
              appearance="outline"
            >
              <mat-label>Vehicle Number</mat-label>
              <input matInput formControlName="carRegistration" />
            </mat-form-field>
          </mat-grid-tile>
          <mat-grid-tile *ngIf="false"
            ><div class="checkbox-container">
              <mat-checkbox
                formControlName="sendQR"
                [checked]="isChecked"
                (change)="onCheckboxChange()"
                >Send Visitor QR</mat-checkbox
              >
            </div></mat-grid-tile
          >
          <mat-grid-tile>
            <div class="notify-host-button">
              <button
                [disabled]="visitorGateEntryPass.invalid || isDisabled"
                mat-raised-button
                [mat-dialog-close]="visitorGateEntryPass.value"
              >
                Mark as Arrived
              </button>
            </div>
          </mat-grid-tile>
          <mat-grid-tile>
            <div class="notify-host-button">
              <button mat-raised-button [mat-dialog-close]="false">
                Cancel
              </button>
            </div>
          </mat-grid-tile>
        </mat-grid-list>
      </form>
    </div>
  </section>
</div>
